import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { Link, ListColumns, Accordion, AccordionPanel, Text, Panel } from 'reaxl';

import {
    formatCurrency,
    formattedNumber,
} from 'atc-js';

const getLinkData = (section, onClick) => {
    const {
        cmpId: cmp,
        links,
    } = section;

    return links.map(({
        makeCode = '',
        modelCode = '',
        value: label,
        url: href,
        listingCount,
        listingType,
        lowestPrice,
        maxPrice,
        title,
        makeName,
        modelName,
    }) => ({
        props: {
            label,
            href,
            title: title !== label && title,
        },
        birf: {
            cmp,
            makeCode,
            modelCode,
        },
        linkItem: {
            listingCount,
            listingType,
            lowestPrice,
            maxPrice,
            makeName,
            modelName,
            label,
            href,
        },
        onClick,
        section: {
            title: section.title,
            type: section.type,
            listingType: section.listingType,
            styleCode: section.styleCode,
        },
    }));
};

const renderLink = ({ props, birf, linkItem, onClick, section }) => {
    const hasPriceCount = !!(linkItem.listingCount && linkItem.lowestPrice);
    const linkClassNames = clsx({
        'display-block margin-bottom-3': !hasPriceCount,
    });

    return (
        <>
            <Link
                {...props}
                onClick={(event) => {
                    onClick(event, { props, ...birf, linkItem, section });
                }}
                className={linkClassNames}
            />
            {hasPriceCount && (
                <div className="text-size-200 margin-bottom-3">
                    {`${formattedNumber({ value: linkItem.listingCount })} vehicles starting at ${formatCurrency(linkItem.lowestPrice)}`}
                </div>
            )}
        </>
    );
};

const renderLinkLists = (seoLinks, onClick) => seoLinks.map((section, i) => (
    <Panel
        key={i}
        alignment="left"
    >
        <Accordion
            defaultActiveKey={-1}
        >
            <AccordionPanel
                title={(
                    <Text
                        data-cmp="heading"
                        transformCase="capitalize"
                        size={400}
                    >
                        {section.title}
                    </Text>
                )}
                eventKey={section.title + i}
                key={section.title + i}
                id={section.title + i}
            >
                <ListColumns
                    className="list-unstyled list-columns"
                    items={getLinkData(section, onClick)}
                    render={renderLink}
                    key="listColumn"
                    md={4}
                    sm={3}
                />
            </AccordionPanel>
        </Accordion>
    </Panel>
));

/**
 *  This will standardized the rendering of SEO deeplinks across pages. Links are stored in AEM
 *  and managed by the content team.
 */

const SeoDeepLinks = React.memo(({
    className,
    seoLinks = [],
    onClick = () => { },
    ...rest
}) => Array.isArray(seoLinks) && seoLinks.length > 0 && (
    <div
        data-cmp="seoDeeplinks"
        className={clsx('deeplinks', className)}
        {...rest}
    >
        {renderLinkLists(seoLinks, onClick)}
    </div>
));

SeoDeepLinks.propTypes = {
    /**
     * The className to apply to the root node
     */
    className: PropTypes.string,
    /**
     * An array of deeplinks
     */
    seoLinks: PropTypes.array,
    /**
     * Callback function fired when a deeplink is clicked
     */
    onClick: PropTypes.func,
};

export default SeoDeepLinks;
